export default "__VITE_ASSET__V9RU3mDZ__"